import qs from 'qs'

export default {
  data: () => ({
    queryParametersParsed: {}
  }),
  methods: {
    handleParsedQueryParameters(callback) {
      // eslint-disable-next-line
      console.assert(callback, 'Callback is required')

      Object.keys(this.queryParametersParsed).forEach((parsedParameterName) => {
        callback(parsedParameterName, this.queryParametersParsed[parsedParameterName])
      })
    }
  },
  computed: {
    queryParametersPresent() {
      return Object.keys(this.queryParametersParsed).length > 0
    }
  },
  created() {
    this.queryParametersParsed = qs.parse(window.location.search, { ignoreQueryPrefix: true })
  }
}
